import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center">
            <div className="text-center px-4 max-w-2xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <ExclamationTriangleIcon className="w-24 h-24 mx-auto mb-8 text-yellow-400" />

                    <h1 className="text-6xl md:text-8xl font-bold text-white mb-4">
                        404
                    </h1>

                    <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
                        Page Not Found
                    </h2>

                    <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                        This feature is coming soon! We're working hard to bring you the best experience.
                        In the meantime, explore our other pages to learn more about Aureus Cambridge School.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            to="/"
                            className="inline-flex items-center bg-yellow-400 text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-yellow-500 transition-colors duration-300 group"
                        >
                            Go Home
                            <ChevronRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
                        </Link>

                        <Link
                            to="/contact"
                            className="inline-flex items-center border-2 border-yellow-400 text-yellow-400 px-8 py-4 rounded-full font-semibold text-lg hover:bg-yellow-400 hover:text-black transition-all duration-300"
                        >
                            Contact Us
                        </Link>
                    </div>

                    <div className="mt-12 text-gray-400">
                        <p className="mb-2">Need immediate assistance?</p>
                        <p className="text-yellow-400 font-semibold">
                            Call us or visit our contact page
                        </p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default NotFound;
